import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import {setupComponents} from "./config/setup-components";
import { VueMaskDirective } from 'v-mask';
import VueSwal from 'vue-swal'

Vue.config.productionTip = false
Vue.directive('mask', VueMaskDirective);
Vue.use(VueSwal)
setupComponents(Vue);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
